import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-interactive-icon',
  templateUrl: './interactive-icon.component.html',
  styleUrls: ['./interactive-icon.component.scss'],
})
export class InteractiveIconComponent  implements OnInit {
  @Input() customClass: string = ""; // image size

  constructor() { }

  ngOnInit() {}

}
